import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IGalleryStore,
} from '../../mobx-store/storeInterfaces/galleryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditGalleryImage.module.scss';

interface IProps extends WithSnackbarProps {
  galleryStore: IGalleryStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
}

@inject('galleryStore')
@inject('countryStore')
@observer
class AddEditGalleryImage extends Component<IProps, IState> {
  isNew = false;

  imageId = -1;

  pageTitle = '';

  imageFormTitle = '';

  imageSchema: any;

  submitButton: any;

  cancelButton: any;

  constructor(props: IProps) {
    super(props);
    if (this.props.match.params.id) {
      this.isNew = false;
      this.imageId = this.props.match.params.id;
      this.pageTitle = translate('editImagePageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addImagePageTitle', {
      });
    }
    this.initGalleryImageSchema();
    this.initState();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.imageFormTitle = translate('imageFormTitle', {
    });
  }

  initGalleryImageSchema = () => {
    this.imageSchema = Yup.object().shape({
      video: Yup.array(),
      image: Yup.array()
        .required('Required'),
    });
  };

  initState = () => {
    this.state = {
      processing: false,
      loadingManagedCountries: true,
      loading: !this.isNew,
      formFields: [
        {
          name: 'image',
          label: translate('addImagePageFormImage', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'image/*',
          size: 200,
        },
        {
          name: 'video',
          label: translate('addImagePageFormVideo', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'video/*',
        },
      ],
    };
  };

  handleSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      this.props.galleryStore.createImage(values)
        .then(() => {
          this.props.history.goBack();
          SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
          }), 8000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    } else {
      this.props.galleryStore.updateImage(values, this.imageId)
        .then(() => {
          this.props.history.goBack();
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    }
  };

  handleCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'Add' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  updateStateWithImageData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.galleryStore.selectedImage[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.pageTitle} />
        <div className={classes.content}>
          {this.state.loading || this.state.loadingManagedCountries
            ? <Spinner />
            : (
              <GeneralFormComponent
                formTitle={this.imageFormTitle}
                fields={this.state.formFields}
                formSchema={this.imageSchema}
                submitButton={this.submitButton}
                cancelButton={this.cancelButton}
                processing={this.state.processing}
              />
            )}
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, galleryStore,
    } = this.props;
    await countryStore.getUserManagedCountries();
    this.setState({
      loadingManagedCountries: false,
    });

    if (!this.isNew) {
      galleryStore.getImageById(this.imageId)
        .then(() => {
          this.updateStateWithImageData();
        }).catch(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }
}
export default AddEditGalleryImage;
